// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#dashboard-project > .sidebar {
  width: 280px;
  min-width: 280px;
  max-width: 280px;
}
#dashboard-project > .center > .header {
  height: auto;
  min-height: auto;
  max-height: auto;
}
#dashboard-project > .center > .header .selected-project {
  background: rgba(0, 0, 0, 0.12);
  color: #FFFFFF;
  padding: 8px 16px;
  height: 40px;
  line-height: 24px;
  font-size: 16px;
  border-radius: 8px 0 0 0;
}
#dashboard-project > .center > .header .project-selector {
  margin-left: 1px;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 0 8px 0 0;
}
#dashboard-project > .center > .header .project-selector mat-icon {
  color: #FFFFFF;
}
#dashboard-project > .center > .content {
  flex: 1;
}
#dashboard-project > .center > .content mat-mdc-tab-group {
  height: 100%;
}
#dashboard-project > .center > .content mat-mdc-tab-group .mat-mdc-tab-body-wrapper {
  flex-grow: 1;
}
#dashboard-project > .center > .content .mat-mdc-tab-label-container {
  padding: 0 24px;
}
#dashboard-project .widget.widget5 .gridline-path.gridline-path-horizontal {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/main/dashboard/dashboard.component.scss"],"names":[],"mappings":"AAEI;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;AADR;AAMQ;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;AAJZ;AAMY;EACI,+BAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;AAJhB;AAOY;EACI,gBAAA;EACA,+BAAA;EACA,wBAAA;AALhB;AAOgB;EACI,cAAA;AALpB;AAUQ;EACI,OAAA;AARZ;AASY;EACI,YAAA;AAPhB;AAQgB;EACI,YAAA;AANpB;AASY;EACI,eAAA;AAPhB;AAgBY;EACI,aAAA;AAdhB","sourcesContent":["#dashboard-project {\n\n    >.sidebar {\n        width: 280px;\n        min-width: 280px;\n        max-width: 280px;\n    }\n\n    >.center {\n\n        >.header {\n            height: auto;\n            min-height: auto;\n            max-height: auto;\n\n            .selected-project {\n                background: rgba(0, 0, 0, 0.12);\n                color: #FFFFFF;\n                padding: 8px 16px;\n                height: 40px;\n                line-height: 24px;\n                font-size: 16px;\n                border-radius: 8px 0 0 0;\n            }\n\n            .project-selector {\n                margin-left: 1px;\n                background: rgba(0, 0, 0, 0.12);\n                border-radius: 0 8px 0 0;\n\n                mat-icon {\n                    color: #FFFFFF;\n                }\n            }\n        }\n\n        >.content {\n            flex: 1;\n            mat-mdc-tab-group {\n                height: 100%;\n                .mat-mdc-tab-body-wrapper {\n                    flex-grow: 1;\n                }\n            }\n            .mat-mdc-tab-label-container {\n                padding: 0 24px;\n            }\n        }\n    }\n\n    .widget {\n\n        &.widget5 {\n\n            .gridline-path.gridline-path-horizontal {\n                display: none;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
